import './styles.scss';

import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import ButtonPrimary from '@components/atoms/buttons/ButtonPrimary';

const ContactBox = ({
	modifiers,
	className,
	title,
	link,
	text,
	...otherProps
}) => {
	const baseClass = 'contact-box';
	const defaultClass = 'box box--gradient';

	const rootClass = cx(baseClass, className, defaultClass, {
		[`${baseClass}--${modifiers}`]: modifiers,
	});

	return (
		<div className={rootClass} data-animation-page {...otherProps}>
			<h2 className="contact-box__title">{title}</h2>
			<div className="contact-box__cta">
				<ButtonPrimary href={link.url} text={link.title} />
				<p>{text}</p>
			</div>
		</div>
	);
};

ContactBox.propTypes = {
	modifiers: PropTypes.string,
	className: PropTypes.string,
	title: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
	link: PropTypes.object.isRequired,
	text: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
};

export default ContactBox;
